const reports = {
  dashboard: {
    title: 'Panel de Reportes',
  },
  errors: {
    noAccessToken: 'Sin Token de Acceso',
    tokenUnavailable: 'Token de acceso del panel no disponible.',
  },
};

export const es = {
  reports,
};
